// extracted by mini-css-extract-plugin
export var child = "colored-section-module--child--527c8";
export var section = "colored-section-module--section--4f5e0";